import { createIcon } from "@chakra-ui/icons";

export const ColoredSymbol = createIcon({
  displayName: "ColoredSymbol",
  viewBox: "0 0 110 88",
  path: (
    <g>
      <path
        d="M38.2781 37.4076C39.0167 37.4462 40.0845 37.6745 41.2235 38.0156C41.443 38.333 41.6536 38.6385 41.8523 38.9203C42.9824 40.5516 43.4956 41.2902 43.8397 41.6698C45.21 43.1706 48.0842 44.0812 48.4075 44.1791C48.4787 44.1999 52.0648 45.2113 54.8767 46.4689L54.9479 46.4985C55.8466 46.8456 56.6979 47.2401 57.5017 47.6731C58.3056 48.8447 58.4687 50.1497 58.2729 51.44C54.408 46.9523 45.8804 43.1914 27.1907 46.1841C28.0865 46.0536 49.5109 43.052 57.57 53.7594C57.4602 54.0086 57.3445 54.2548 57.2229 54.492C56.7928 54.0501 56.3123 53.6616 55.7873 53.3294C55.7843 53.3264 55.7843 53.3264 55.7843 53.3264C53.1563 51.6654 49.4427 51.3718 45.6104 52.5849C43.4363 53.1514 40.9833 54.1925 40.9833 54.1925C40.9833 54.1925 39.1176 54.934 37.9637 54.7531C36.8188 54.5751 29.0267 51.7751 20.1223 50.4493C15.6791 49.7879 0.949167 48.901 0 48.9574C0.0504245 48.9218 19.3363 36.411 38.2781 37.4076Z"
        fill="url(#paint0_linear_91_12992)"
      />
      <path
        d="M55.6971 58.7193C55.6971 58.7193 63.9964 50.3105 57.1861 45.9593C57.112 45.906 57.0349 45.8585 56.9518 45.811C56.5039 45.5649 56.0115 45.3246 55.4954 45.0933C59.7133 46.7305 64.3168 48.9699 67.3393 51.7431C68.3804 56.3702 68.0304 61.279 65.4647 66.2827C64.4473 67.0954 63.2667 67.9289 61.9023 68.7772C61.7184 68.8632 61.5316 68.9492 61.3476 69.0352C56.8747 71.1263 52.4492 73.3241 48.089 75.6495C45.5766 76.9872 43.088 78.3694 40.6321 79.8109C36.349 82.3261 32.2201 84.9985 28.7823 87.6739C28.726 87.5078 55.6971 58.7193 55.6971 58.7193Z"
        fill="url(#paint1_linear_91_12992)"
      />
      <path
        d="M69.9353 61.3626C76.9503 53.7577 70.7985 36.952 67.9094 30.2547C67.9094 30.2458 67.9005 30.2458 67.9005 30.2458C67.7196 29.8128 67.2866 28.742 66.6963 27.4192C70.7095 18.2155 79.6139 15.899 89.3102 23.1569C89.3102 23.1569 98.0752 18.7464 109.002 19.132C109.002 19.132 91.4399 21.1697 86.7297 29.439C82.0194 37.7143 81.263 48.9111 73.4561 61.0601C72.0443 63.2579 70.223 64.646 68.209 65.7642C68.0637 65.8443 67.9124 65.9185 67.7641 65.9985C68.5323 64.8032 69.3451 63.2431 69.9353 61.3626Z"
        fill="#2C6DB0"
      />
      <path
        d="M60.9032 21.4416C62.4249 22.7971 64.6851 25.9945 66.1059 28.9012C66.9809 30.6986 67.6305 32.2469 67.8737 32.7897C67.8737 32.7897 67.8826 32.7897 67.8826 32.7986C71.1661 40.0535 78.5578 59.3091 68.2059 65.7632C68.0635 65.8522 67.9004 65.9293 67.7491 66.0153C71.9225 59.5375 77.5463 42.3077 40.5199 21.314C40.5199 21.314 78.7565 43.42 64.8393 67.4302C64.6969 67.4954 64.5575 67.5607 64.4122 67.6289C63.899 67.8543 63.3859 68.0886 62.8728 68.3229L61.8999 68.7767C66.6487 64.3514 67.7521 59.4129 66.2571 55.0795C66.2571 55.0706 66.2571 55.0706 66.2571 55.0706C64.8008 50.841 60.8884 47.172 55.4989 45.0899C52.5476 43.77 48.8547 42.7348 48.8547 42.7348C48.8547 42.7348 46.0903 41.8895 44.9572 40.6497C43.8331 39.4188 37.5953 29.269 28.7858 19.7717C24.3929 15.0319 8.63972 0.791935 7.52148 0C7.60157 0 40.5199 3.28935 60.9032 21.4416Z"
        fill="url(#paint2_linear_91_12992)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_91_12992"
          x1="58.356"
          y1="46.0751"
          x2="0.00707399"
          y2="46.0751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68D391" />
          <stop offset="1" stopColor="#2F855A" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_91_12992"
          x1="67.8845"
          y1="66.3826"
          x2="28.7843"
          y2="66.3826"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68D391" />
          <stop offset="1" stopColor="#48BB78" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_91_12992"
          x1="18.7514"
          y1="57.5602"
          x2="78.8471"
          y2="-5.23655"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#68D391" />
          <stop offset="1" stopColor="#48BB78" />
        </linearGradient>
      </defs>
    </g>
  ),
});
